export function Unauthorized() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-3">
      <p className="text-4xl">🔒</p>
      <h2 className="text-text-primary font-semibold text-lg">Sin permiso</h2>
      <p className="text-text-muted text-sm">No tenés acceso a esta sección.</p>
    </div>
  )
}
